module.exports = __webpack_public_path__ + "static/media/watson-marlow.eaf3312e.png";